import React, { useState } from "react";
import {
  OptionContainer,
  OptionContent,
  OptionLabel,
  SettingsOptionContainer,
} from "../../../styles";
import { useTranslation } from "react-i18next";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { useNewsStore } from "../../../../../../../stores/use-news-store";
import BlogPicker from "../../../../../../../components/ui/blog-picker/BlogPicker";
import ReorderableBlogs from "./ReorderableBlogs";
import { useBlogs } from "../../../../../../../features/news/useBlogs";

function Manual() {
  const { t } = useTranslation();
  const [pickerKey, setPickerKey] = useState(crypto.randomUUID());

  const { data, selectedTab, updateConfigTab } = useNewsStore((state) => ({
    data: state.data,
    selectedTab: state.getSelectedTab(),
    updateConfigTab: state.updateConfigTab,
  }));

  const onSelect = ({ selectedBlog }) => {
    if (
      !selectedBlog ||
      !!data.config.tabs[selectedTab].manuallyPicked.find(
        (blog) => String(selectedBlog.contentId) === String(blog.contentId)
      )
    ) {
      return;
    }

    const currentLastPicked =
      data.config.tabs[selectedTab].manuallyPicked.length > 0
        ? data.config.tabs[selectedTab].manuallyPicked[
            data.config.tabs[selectedTab].manuallyPicked.length - 1
          ]
        : null;

    const position = currentLastPicked ? currentLastPicked.position + 1 : 0;

    updateConfigTab({
      value: {
        manuallyPicked: [
          ...data.config.tabs[selectedTab].manuallyPicked,
          {
            id: crypto.randomUUID(),
            position,
            contentId: selectedBlog.contentId,
          },
        ],
      },
    });

    setPickerKey(Math.random().toString(36).substring(7));
  };

  const blogQueries = useBlogs(
    data.config?.tabs[selectedTab]?.manuallyPicked || []
  );

  const selectedBlogs =
    data.config?.tabs[selectedTab]?.manuallyPicked?.map(
      (blog) => blog.contentId
    ) || [];

  const removeBlog = (id) => {
    const newManuallyPicked = data.config.tabs[
      selectedTab
    ].manuallyPicked.filter((blog) => blog.id !== id);
    updateConfigTab({
      value: {
        manuallyPicked: newManuallyPicked,
      },
    });

    setPickerKey(crypto.randomUUID());
  };

  const resetOrder = (list) => {
    const resetList = list.map((c, index) => {
      const slide = c;
      slide.order = index + 1;
      return slide;
    });
    return resetList;
  };

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return resetOrder(result);
  };

  const reorderPanels = (sourceId, targetId) => {
    if (sourceId === targetId) {
      return;
    }
    const copyOfBlogs = [...blogQueries.map(({ data }) => data)];
    const sourceIndex = sourceId;
    const targetIndex = targetId;
    const items = reorder(copyOfBlogs, sourceIndex, targetIndex);

    updateConfigTab({
      value: {
        manuallyPicked: items,
      },
    });
  };

  return (
    <>
      <>
        <SettingsOptionContainer>
          <OptionContainer direction="column">
            <OptionLabel>{t("blogs")}</OptionLabel>
            <OptionContent full>
              <BlogPicker
                key={selectedBlogs.join("-")}
                selectedBlogs={selectedBlogs}
                onSelect={(selectedBlog) => onSelect({ selectedBlog })}
              />
            </OptionContent>
          </OptionContainer>

          <DndProvider backend={HTML5Backend}>
            <OptionContainer direction="column">
              {blogQueries.map(({ data }, _idx) => (
                <ReorderableBlogs
                  blog={data}
                  index={_idx}
                  reorderPanels={reorderPanels}
                  removeBlog={removeBlog}
                />
              ))}
            </OptionContainer>
          </DndProvider>
        </SettingsOptionContainer>
      </>
    </>
  );
}

export default Manual;
